import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Record } from "appworks/model/gameplay/records/record";
import { builderManager } from "appworks/server/builders/builder-manager";
import { RecordBuilder } from "appworks/server/builders/record-builder";
import { Services } from "appworks/services/services";
import { PartnerConnectSpinRequestPayload } from "partner-connect/integration/schema/partner-connect-spin-schema";
import { PartnerConnect, PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { slotDefinition } from "slotworks/model/slot-definition";

export class TGRPartnerConnectSpinRecordBuilder implements RecordBuilder {
    public id: string = "TGRPartnerConnectSpinRecordBuilder";

    public filter(request: PartnerConnectSpinRequestPayload, response: PartnerConnect.SpinResponse): boolean {
        return request instanceof PartnerConnectSpinRequestPayload && request.type !== "restore" && request.cmd !== "C" && response !== undefined;
    }

    public build(gameplay: Gameplay, request: PartnerConnectSpinRequestPayload, response: PartnerConnect.SpinResponse): Record[] {
        const baseRecord: boolean = !gameplay.getCurrentRecord() || !gameplay.areFreespinsPending();

        const record: SpinRecord = (baseRecord) ? new SpinRecord() : new FreespinRecord();

        if (baseRecord) {
            record.wager = Services.bet.getTotalStake();
        }

        const eventData = response.wager.bets[response.wager.bets.length - 1].eventdata;

        PartnerConnectManager.prepaidData = response.prepaid;
        const nonPrepaidWin = Math.round(eventData.accWa * 100);
        const prepaidWin = response.prepaid?.collect?.win ?? 0;
        record.cashWon = nonPrepaidWin + Math.round(prepaidWin * 100);
        record.gamble = false;
        record.reelset = slotDefinition.reelsets.get("base");
        if (eventData.response?.clientData?.spinCalcResult) {
            record.grid = this.convertSymbolIDs(eventData.response.clientData.spinCalcResult.reelsView);
        }

        record.results = [];
        response.wager.bets.forEach((result) => {
            record.results.push(...builderManager.buildResults(record, result));
        });

        const results = builderManager.buildResults(record, response);
        record.results.push(...results);

        const freespins = record.getResultsOfType(FreespinWinResult).reduce((prev: number, curr: FreespinWinResult) => prev + curr.freespinsWon, 0);
        const totalfreespins = freespins + ((gameplay.getCurrentRecord()) ? gameplay.getTotalFreespinsWon() : 0);

        record.lastChild = totalfreespins === 0;
        record.hasChildren = freespins > 0 && (!gameplay.getCurrentRecord() || !gameplay.areFreespinsPending());
        const totalFreespinsWin = (gameplay.getCurrentRecord()) ? gameplay.getTotalWin() : 0;

        if (response.prepaid?.state) {
            // balance shouldn't change until prepaids have finished
            gameplay.balance = gameplay.startBalance;
        } else {
            gameplay.balance = gameplay.startBalance + record.cashWon + totalFreespinsWin;
        }

        return [record];
    }

    protected convertSymbolIDs(symbols: string[][]): string[][] {
        return symbols.map(
            (reel) => reel.map(
                (symbol) => slotDefinition.symbolDefinitions[symbol].id
            )
        );
    }
}

export const tgrPartnerConnectSpinRecordBuilder = new TGRPartnerConnectSpinRecordBuilder();
